import FBMedication from "./container/MedicationLanding";

export default FBMedication;
